import React, { createContext, useContext, useState } from "react";

const ProjectTOCContext = createContext(null);

export function ProjectTOCProvider({ children }) {
  const [items, setItems] = useState(null);
  const [activeSection, setActiveSection] = useState("");

  return (
    <ProjectTOCContext.Provider
      value={{ items, setItems, activeSection, setActiveSection }}
    >
      {children}
    </ProjectTOCContext.Provider>
  );
}

export function useProjectTOC() {
  const ctx = useContext(ProjectTOCContext);
  if (!ctx) {
    throw new Error("useProjectTOC must be used within ProjectTOCProvider");
  }
  return ctx;
}
